import {
  Box,
  Divider,
  List,
  SwipeableDrawer,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import { setOpenAuthSidebar } from "../../../../redux/features/settingSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import LogoSe from "../../../../media/images/logos/KarenTarabarNet-App.png";
import CustomListItem from "./components/ListItem";
import ThemeToggle from "../../../components/ThemeToggle";
import InfoCircle from "../../../../media/images/icons/info-circle";
import GuidSVG from "../../../../media/images/icons/guid-icon";
import DashboardIcon from "../../../../media/images/icons/dashboard";
import PhoneOutlineSVG from "../../../../media/images/icons/phone-outline";
import { useLocation } from "react-router-dom";
import logoimage from "../../../../media/images/logos/Logo-Karen.png";
import RefreshSVG from "../../../../media/images/icons/refresh";
import { triggerServiceWorkerUpdate } from "../../../../utils/serviceWorkerUpdate";

export default function AuthSidebar() {
  const { authSidebar } = useAppSelector((state) => state.settings);
  const dispatch = useAppDispatch();
  const [isUpdating, setIsUpdating] = useState(false);

  const { pathname } = useLocation();

  const handleUpdateApp = async () => {
    if (isUpdating) return;
    setIsUpdating(true);
    try {
      const result = await triggerServiceWorkerUpdate();
      if (!result.reloaded && result.message) {
        dispatch(setSnackbarDescription(result.message));
        dispatch(setSnackbarErrorStatus(result.success ? 200 : 400));
        dispatch(setOpenSnackbar(true));
      }
    } finally {
      setIsUpdating(false);
    }
  };

  const theme = useTheme();

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      dispatch(setOpenAuthSidebar(open));
    };

  return (
    <Box>
      <style>{`
      .sidebarDrawer {
  max-width: 450px;
  z-index:3000;
  margin-right: auto;
  margin-left: auto;
  /* overflow-x: visible; */
  overflow-y: hidden;
}
      `}</style>
      <SwipeableDrawer
        className="sidebarDrawer"
        dir="rtl"
        sx={{
          "& .MuiPaper-root": {
            width: 270,
            position: "absolute",
            bgcolor: "bgColor.blueGrey50",
            right: "0px",
            top: "0px",
            bottom: "0px",
            height: "auto",
            // borderRadius: "15px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: 3,
            paddingX: "10px",
            paddingY: "8px",
          },
        }}
        anchor="right"
        open={authSidebar}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableSwipeToOpen={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <ThemeToggle />
          </Box>

          <Box
            sx={{
              backgroundColor: theme.palette.bgColor.white,

              // border: "1px solid gray",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "6px",
                paddingY: "8px",
              }}
            >
              <img width={180} src={LogoSe} alt="" />
            </Box>

            <Box
              sx={{
                width: "100%",
                maxWidth: 360,
                overflow: "hidden",
                gap: "8px",
                display: "flex",
                flexDirection: "column",
                padding: "0px 8px 16px 8px",
              }}
              dir="rtl"
            >
              {/* <nav aria-label="main mailbox folders">
              <List>
                <CustomListItem path="/" title="پیشخوان" icon={HomeIcon} />
              </List>
            </nav> */}
              {/* <CustomAccordion
              Icon={<UserRegister color={theme.palette.textColor.main} />}
              title="ثبت نام"
            />
            <CustomAccordion
              Icon={<LoginSVG color={theme.palette.textColor.main} />}
              title="ورود به حساب"
            /> */}
              {/* <CustomAccordion icon="" title="ورود به حساب" /> */}
              <nav
                style={{
                  padding: "0px 8px",
                }}
                aria-label="main mailbox folders"
              >
                {/* <List>
                <CustomListItem path="/" title="پیشخوان" icon={HomeIcon} />
              </List> */}
                <List
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <CustomListItem
                    path="/"
                    title="پیشخوان"
                    icon={
                      <DashboardIcon
                        size={20}
                        color={
                          pathname === "/"
                            ? "#fff"
                            : theme.palette.textColor.main
                        }
                      />
                    }
                  />
                  <Divider variant="middle" />
                  <CustomListItem
                    path="/guides"
                    title="راهنما"
                    icon={
                      <GuidSVG
                        size={20}
                        color={
                          pathname === "/guides"
                            ? "#fff"
                            : theme.palette.textColor.main
                        }
                      />
                    }
                  />
                  <Divider variant="middle" />
                  {/* <CustomListItem
                  path="/terms"
                  title="قوانین"
                  icon={
                    <InfoCircle
                      size={20}
                      color={theme.palette.textColor.main}
                    />
                  }
                /> */}
                  {/* <CustomListItem
                  path="/courses"
                  title="آموزش ویدئویی"
                  icon={
                    <VideoPlaySVG
                      size={20}
                      color={theme.palette.textColor.main}
                    />
                  }
                />
                <Divider variant="middle" /> */}
                  <CustomListItem
                    path="/terms"
                    title="قوانین و مقررات"
                    icon={
                      <InfoCircle
                        size={20}
                        color={
                          pathname === "/terms"
                            ? "#fff"
                            : theme.palette.textColor.main
                        }
                      />
                    }
                  />
                  {/* <Divider variant="middle" /> */}
                  {/* <CustomListItem
                  path="/notifs"
                  title="اعلان‌ها"
                  icon={<NotifSVG2 colo/>}
                /> */}
                  <Divider variant="middle" />
                  <CustomListItem
                    path="/aboutus"
                    title="درباره کارن ترابر نت"
                    icon={
                      <img width={28} src={logoimage} alt="" />

                      // <LogoKarenSVG
                      //   size={20}
                      //   color={
                      //     pathname === "/aboutus"
                      //       ? "#fff"
                      //       : theme.palette.textColor.main
                      //   }
                      // />
                    }
                  />
                  <Divider variant="middle" />
                  <CustomListItem
                    title={isUpdating ? "در حال بروزرسانی..." : "به روز رسانی"}
                    icon={
                      <RefreshSVG
                        size={20}
                        color={theme.palette.textColor.main}
                      />
                    }
                    actionOnly
                    handleClick={handleUpdateApp}
                  />
                </List>
              </nav>
            </Box>
          </Box>
          {/* <Box
          sx={{
            backgroundColor: "background.default",
            // border: "1px solid gray",
            borderRadius: "10px",
            width: "100%",
            maxWidth: 360,
          }}
        >
          <nav
            style={{
              padding: "0px 8px",
            }}
            aria-label="main mailbox folders"
          >
            <List
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <CustomListItem path="/guides" title="راهنما" icon={GuidIcon} />
              <Divider variant="middle" />
              <CustomListItem
                path="/courses"
                title="آموزش ویدئویی"
                icon={LearnVideoIcon}
              />
              <Divider variant="middle" />
              <CustomListItem path="/terms" title="قوانین" icon={TermsIcon} />
              <Divider variant="middle" />
              <CustomListItem
                path="/notifs"
                title="اعلان‌ها"
                icon={NotifIcon}
              />
              <Divider variant="middle" />
              <CustomListItem
                path="/aboutus"
                title="درباره کارن ترابر نت"
                icon={TermsIcon}
              />
            </List>
          </nav>
        </Box> */}
          <Box
            sx={{
              backgroundColor: theme.palette.bgColor.white,
              // border: "1px solid gray",
              borderRadius: "10px",
              padding: "16px",
              width: "100%",
              maxWidth: 360,
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <PhoneOutlineSVG color={theme.palette.textColor.main} />
              {/* <img width={20} src={CallIcon} alt="" /> */}
              <Typography
                sx={{
                  fontWeight: "600",
                }}
              >
                شماره مرکز تماس:
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
           09108107185
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <Typography>نسخه : 0.1.5</Typography>
        </Box>
      </SwipeableDrawer>
    </Box>
  );
}
